import { render, staticRenderFns } from "./SettlementTask.vue?vue&type=template&id=107c64cb&scoped=true"
import script from "./SettlementTask.vue?vue&type=script&lang=js"
export * from "./SettlementTask.vue?vue&type=script&lang=js"
import style0 from "./SettlementTask.vue?vue&type=style&index=0&id=107c64cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107c64cb",
  null
  
)

export default component.exports